import { api } from './api';

export interface CategoriaArticolo {
  id: number;
  nome: string;
  descrizione?: string;
  colore?: string;
  icona?: string;
  costoGestioneMedio?: number;
  isActive: boolean;
  parentId?: number;
  parentNome?: string;
  children?: CategoriaArticolo[];
  articoliCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CategoriaArticoloRequest {
  nome: string;
  descrizione?: string;
  colore?: string;
  icona?: string;
  costoGestioneMedio?: number;
  isActive?: boolean;
  parentId?: number;
}

/**
 * Get all categorie articoli
 */
const getCategorieArticoli = async (): Promise<CategoriaArticolo[]> => {
  const response = await api.get<CategoriaArticolo[]>('/categorie-articoli');
  return response.data;
};

/**
 * Get active categorie articoli
 */
const getCategorieArticoliActive = async (): Promise<CategoriaArticolo[]> => {
  const response = await api.get<CategoriaArticolo[]>('/categorie-articoli/active');
  return response.data;
};

/**
 * Get categorie articoli tree (with children)
 */
const getCategorieArticoliTree = async (): Promise<CategoriaArticolo[]> => {
  const response = await api.get<CategoriaArticolo[]>('/categorie-articoli/tree');
  return response.data;
};

/**
 * Get a single categoria articolo by ID
 */
const getCategoriaArticoloById = async (id: number): Promise<CategoriaArticolo> => {
  const response = await api.get<CategoriaArticolo>(`/categorie-articoli/${id}`);
  return response.data;
};

/**
 * Create a new categoria articolo
 */
const createCategoriaArticolo = async (categoria: CategoriaArticoloRequest): Promise<CategoriaArticolo> => {
  const response = await api.post<CategoriaArticolo>('/categorie-articoli', categoria);
  return response.data;
};

/**
 * Update an existing categoria articolo
 */
const updateCategoriaArticolo = async (
  id: number,
  categoria: CategoriaArticoloRequest
): Promise<CategoriaArticolo> => {
  const response = await api.put<CategoriaArticolo>(`/categorie-articoli/${id}`, categoria);
  return response.data;
};

/**
 * Delete a categoria articolo
 */
const deleteCategoriaArticolo = async (id: number): Promise<void> => {
  await api.delete(`/categorie-articoli/${id}`);
};

const categorieArticoliService = {
  getCategorieArticoli,
  getCategorieArticoliActive,
  getCategorieArticoliTree,
  getCategoriaArticoloById,
  createCategoriaArticolo,
  updateCategoriaArticolo,
  deleteCategoriaArticolo,
};

export default categorieArticoliService;
